import React, {useState, useEffect} from "react"
import conword from "conword"

// components
import Features from "./Features"

// the component
function WeatherAndSeason({activity, activityVariant}) {
  // state
  const [items, setItems] = useState([])

  // side effects
  useEffect(() => {
    let wnsItems = []

    // add weather conditions
    if(activityVariant.weatherConditions.length === 0) {
      wnsItems.push({key:"weather", text:"wetterunabhängig"})
    }
    else {
      activityVariant.weatherConditions.forEach(wc => {
        wnsItems.push({
          key:wc._id,
          text:wc.title["de"]
        })
      })
    }
    
    // add the available season
    if(activityVariant.availableMonths.length === 12) {
      wnsItems.push({key:"season", text:"ganzjährig"})
    }
    else {
      let season = conword.months(activityVariant.availableMonths, {
        language:"de",
        zeroBased:false,
        connector:'-'
      }).periods.join(', ')
      wnsItems.push({key:"season", text:season})
    }

    // add availableTimes text
    if(activity.availableTimes && activity.availableTimes.trim().length > 0) {
      wnsItems.push({key:"availableTimes", text:activity.availableTimes.trim()})
    }

    // update the state
    setItems(wnsItems)
  }, [activityVariant])

  // render
  return (
    <Features 
      title="Saison & Wetterbedingungen" 
      items={items}
    />
  )
}

export default WeatherAndSeason